import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  logoutGrid: {
    margin: theme.spacing(2),
    justifyContent: 'center',
  },
  loadingPaper: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    textAlign: 'center',
  },
  loadingPaperProgress: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export default useStyles;
